import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useEffect, useMemo, useSyncExternalStore } from 'react';
import RecordingsPageInternal from '../RecordingsPage/RecordingsPageInternal';
import ClipPlayerWrapper from '../Clip/ClipPlayer/ClipPlayerWrapper';
import { NavigationEndpoint } from '../SessionDetail/types';
import { useSetFirstClipAsDefault } from './useSetFirstClipAsDefault';
import { core } from '@/stores/core';
import useSavedSearch from '@/hooks/useSavedSearch';

const NewClipListPage = () => {
  const navigate = useNavigate();
  const handleTranscriptError = (err: any) => {
    navigate(`/error/${err?.statusCode}`, { replace: true });
  };
  const { eventId, broadcastId } = useParams<{
    eventId: string;
    broadcastId: string;
  }>();

  const [searchParams] = useSearchParams();

  const clipId = useMemo(() => {
    return searchParams.get('activeClipId');
  }, [searchParams]);

  const coreStore = useSyncExternalStore(core.subscribe, core.getSnapshot);

  const { isSavedSearchPage } = useSavedSearch();

  useSetFirstClipAsDefault({ enabled: isSavedSearchPage });

  useEffect(() => {
    if (!clipId && !isSavedSearchPage) {
      navigate(`/${eventId}/${broadcastId}/${NavigationEndpoint.recordings}`, { replace: true });
    }
  }, [clipId, eventId, broadcastId, navigate, isSavedSearchPage]);

  if (!coreStore.content && !isSavedSearchPage) {
    return <></>;
  }

  if (!clipId) {
    return <div>No clip selected</div>;
  }

  return (
    <ClipPlayerWrapper
      isSavedSearchPage={isSavedSearchPage}
      useNewSkeletonLoader
      clipId={clipId}
      handleTranscriptError={handleTranscriptError}
      parentContext="NewClipListPage"
    >
      <RecordingsPageInternal canShow />
    </ClipPlayerWrapper>
  );
};

export default NewClipListPage;
